var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99509 0.5C3.5795 0.5 9.99386e-05 4.07983 0 8.49516C0 12.9105 3.5795 16.4903 7.99509 16.4903C9.83066 16.4903 11.5533 15.8417 12.9029 14.8013L17.2706 19.2077C17.6609 19.5974 18.3169 19.5974 18.7073 19.2077C19.0976 18.8169 19.0976 18.1613 18.7073 17.7706L14.304 13.3972C15.3442 12.048 15.9902 10.3311 15.9902 8.49516C15.9902 4.07983 12.4107 0.5 7.99509 0.5ZM7.99509 2.49879C11.3068 2.49879 13.9913 5.18317 13.9914 8.49516C13.9914 11.8072 11.3068 14.4915 7.99509 14.4915C4.68342 14.4915 1.99887 11.8072 1.99877 8.49516C1.99877 5.18317 4.68342 2.49879 7.99509 2.49879Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.4c0c1b7f0b1a884140ec70323dcd0176.svg";
export { ForwardRef as ReactComponent };